import { Autocomplete, Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import { useEffect, useState } from "react";
import ibsData from "../../../data/static/lista_ibs_cbs.json";
import PercentNumberField from "../../../../components/shared/inputs/PercentNumberField";
import AutocompleteWithRender from "../../../../components/shared/inputs/AutoCompleteWithRender";

const operationIndicatorOptions = ibsData.map(item => ({
    label: `${item.code} - ${item.description}`,
    value: item.code
}));

const FiscalConfigTaxReform = ({ onValidityChange, data, setData }) => {

    useEffect(() => {
        const isValid = data.sendIbsCbs === true
            ? !!(data.ibsCbsTaxSituationCode && data.ibsCbsTaxClassification && data.ibsCbsOperationIndicator)
            : true;

        onValidityChange?.(isValid);
    }, [data, onValidityChange]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AccountBalanceRoundedIcon sx={{ color: 'primary.main' }} />
                    <Typography variant='h6' sx={{ color: 'primary.main' }}>Reforma Tributária</Typography>
                </Box>
                <Box sx={{ width: '49rem' }}>
                    <Typography variant="body1" sx={{ color: 'text.primary' }}>
                        Um novo sistema de cobrança de impostos no Brasil está sendo implementado gradualmente a partir de 2026 e, com isso,
                        algumas informações novas serão necessárias para a emissão de notas fiscais.
                    </Typography>
                </Box>
            </Box>
            <Box>
                <FormLabel sx={{ color: 'text.primary' }}><b> Aderir antecipadamente à Reforma Tributária? </b></FormLabel>
                <Box>
                    <FormControl>
                        <RadioGroup
                            row
                            sx={{ gap: '2rem' }}
                            value={data.sendIbsCbs}
                            onChange={(e) => setData({ ...data, sendIbsCbs: e.target.value === 'true' })}
                        >

                            <FormControlLabel value={false} control={<Radio />} label="Não" />
                            <FormControlLabel value={true} control={<Radio />} label="Sim" />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>
            {data.sendIbsCbs === true && (
                <>
                    <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Código de Situação Tributária de IBS e CBS </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                            <TextField
                                variant="outlined"
                                placeholder='Ex: 01'
                                sx={{ maxWidth: '22rem' }}
                                value={data.ibsCbsTaxSituationCode}
                                onChange={(e) => setData({ ...data, ibsCbsTaxSituationCode: e.target.value })}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Classificação Tributária </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                            <TextField
                                variant="outlined"
                                placeholder='Ex: 123'
                                sx={{ maxWidth: '10.75rem' }}
                                value={data.ibsCbsTaxClassification}
                                onChange={(e) => setData({ ...data, ibsCbsTaxClassification: e.target.value })}
                            />
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormLabel sx={{ mb: 1.3, color: 'text.primary' }}><b>Indicador da Operação </b> <FormLabel sx={{ color: 'error.main' }}><b>*</b></FormLabel></FormLabel>
                        <AutocompleteWithRender
                            options={operationIndicatorOptions}
                            value={operationIndicatorOptions.find(opt => opt.value === data.ibsCbsOperationIndicator)}
                            sx={{ width: '30rem' }}
                            onChange={(val) => { setData({ ...data, ibsCbsOperationIndicator: val?.value || "" })}}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', gap: '1.5rem' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota IBS Municipal </b></FormLabel>
                            <PercentNumberField
                                value={data.ibsMunicipalRate || null}
                                onChange={(e) => setData({ ...data, ibsMunicipalRate: e.target.value })}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota IBS Estadual </b></FormLabel>
                            <PercentNumberField
                                value={data.ibsStateRate || null}
                                onChange={(e) => setData({ ...data, ibsStateRate: e.target.value })}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormLabel sx={{ color: 'text.primary' }}><b> Alíquota CBS </b></FormLabel>
                            <PercentNumberField
                                value={data.cbsRate || null}
                                onChange={(e) => setData({ ...data, cbsRate: e.target.value })}
                            />
                        </Box>
                    </Box>
                </>
            )}
        </Box>
    );
}

export default FiscalConfigTaxReform;